module.exports = __webpack_public_path__ + "img/setting-treatment-desktop-ru.c2f20a90.png";